export default __webpack_public_path__ + "media/SILVER PACKAGE.1252caf719a620aeb89461bd0f24d3d0.mp4";